import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore, isTokenExpired } from '../store/authStore';
import { playLogoutSound } from './useSound';

const CHECK_INTERVAL_MS = 30 * 1000;

/**
 * Hook que verifica periódicamente si el token expiró.
 * Muestra un modal amigable y redirige al login al aceptar.
 */
export function useTokenGuard() {
  const { token, isAuthenticated, logout } = useAuthStore();
  const navigate = useNavigate();
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) return;

    const check = () => {
      if (isTokenExpired(token)) {
        setShowModal(true);
        if (intervalRef.current) clearInterval(intervalRef.current);
      }
    };

    check();
    intervalRef.current = setInterval(check, CHECK_INTERVAL_MS);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [token, isAuthenticated]);

  const handleAccept = () => {
    setShowModal(false);
    playLogoutSound();
    logout();
    navigate('/login', { replace: true });
  };

  return { showModal, handleAccept };
}
